
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.157 12.548l-.035 1.467-1.435-.077.032-1.427c-1.419-.156-2.773-.635-3.55-1.241l.827-1.557c.707.525 1.733.932 2.764 1.08l.053-2.19c-1.587-.439-3.355-1.019-3.31-2.894.035-1.39 1.166-2.52 3.44-2.634l.035-1.454 1.436.077-.034 1.43c1.075.135 2.119.455 2.895.956l-.756 1.574a6.45 6.45 0 00-2.182-.8l-.052 2.227c1.587.426 3.326 1.006 3.282 2.855-.031 1.363-1.149 2.483-3.41 2.608zm-1.3-5.87l.044-1.862c-.765.117-1.075.48-1.085.913-.01.462.414.732 1.041.949zM9.254 9.97c.01-.46-.4-.73-1.012-.962L8.2 10.817c.718-.102 1.043-.425 1.054-.846z","fill":"#CD9E64"}})])
          )
        }
      }
    